import { create } from "zustand";
import { pushAppUrl } from "../routing/urlHistory.js";
import { isSyncingFromUrl } from "../routing/urlRouting.js";
import { useNavigationStore } from "./navigationStore.js";

function pushAccountsUrl({ replace = false } = {}) {
  const { detailAccountId, detailTab } = useAccountsStore.getState();
  pushAppUrl(
    {
      routeId: useNavigationStore.getState().active,
      accountId: detailAccountId,
      tab: detailTab,
    },
    { replace },
  );
}

export const useAccountsStore = create((set) => ({
  detailAccountId: null,
  detailTab: "info",

  openAccountDetail: (accountId, tab = "info", { fromUrl = false } = {}) => {
    set({ detailAccountId: accountId, detailTab: tab });
    if (!fromUrl && !isSyncingFromUrl()) {
      pushAccountsUrl();
    }
  },

  closeAccountDetail: ({ fromUrl = false } = {}) => {
    set({ detailAccountId: null, detailTab: "info" });
    if (!fromUrl && !isSyncingFromUrl()) {
      pushAccountsUrl();
    }
  },

  setAccountDetailTab: (detailTab, { fromUrl = false } = {}) => {
    set({ detailTab });
    if (!fromUrl && !isSyncingFromUrl()) {
      pushAccountsUrl({ replace: true });
    }
  },
}));

export const useDetailAccountId = () => useAccountsStore((s) => s.detailAccountId);
export const useAccountDetailTab = () => useAccountsStore((s) => s.detailTab);
export const useOpenAccountDetail = () => useAccountsStore((s) => s.openAccountDetail);
export const useCloseAccountDetail = () => useAccountsStore((s) => s.closeAccountDetail);
export const useSetAccountDetailTab = () => useAccountsStore((s) => s.setAccountDetailTab);
